var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"header_back":true,"header_setting":true}}),_c('gallery-write-component',{attrs:{"gallery-type":'galleryAdd'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }